import { bind } from 'decko';
import { inject } from 'dependable-react';
import { camelCase, get } from 'lodash';

import { APP_DATA_TOKEN } from '../services/InjectTokens';
import { languageTags } from './languageTags';
type SubstitueKeyVaulePair = Record<string, string>;

// tslint:disable-next-line: export-name
export class I18n {
  private appState = inject(APP_DATA_TOKEN);

  private notifiedFor: Array<string> = [];

  public resolveLanguageTag(langCode: string): string {
    let resolvedLanguage = '';
    languageTags.map((langTag) => {
      if (langTag.code === langCode) {
        resolvedLanguage = this.t(langTag.name.toLowerCase());
      }
    });
    return resolvedLanguage;
  }

  public t(key: string, subs?: SubstitueKeyVaulePair) {
    try {
      const value = this.resolveValue(key);

      if (!subs) {
        return value;
      }

      return this.substitue(value, subs);
    } catch (e) {
      this.notifyMissing(e.message);

      return e.message;
    }
  }

  @bind
  public notifyMissingTranslations() {
    // tslint:disable-next-line:no-console
    console.log(this.notifiedFor.join(', '));
  }

  private notifyMissing(translation: string) {
    if (this.notifiedFor.indexOf(translation) < 0) {
      // tslint:disable-next-line:no-console
      console.log('missing translation', translation);
      this.notifiedFor.push(translation);
    }
  }

  private resolveValue(key: string) {
    const { translations, currentLanguage, currentAppLanguage } = this.appState;
    const lang = key.includes('content') ? currentLanguage : currentAppLanguage;

    const translation = translations[lang][camelCase(key)];
    if (translation) {
      return translation;
    }

    const complexTranslation = get(translations[lang], key);

    if (complexTranslation) {
      return complexTranslation;
    }

    throw new Error(`${lang}:${key}`);
  }

  /*
    Taken from https://github.com/DarkoKukovec/I18n-harmony/blob/master/I18n.js#L121
  */
  private substitue(t: string, args: SubstitueKeyVaulePair) {
    const regex = /\%\{\s*([a-zA-Z0-9\-\_]+)\s*\}/g;
    let match = regex.exec(t);
    let lastIndex = 0;
    // tslint:disable-next-line: prefer-const
    let keepPlaceholder;
    while (match) {
      let arg = args[camelCase(match[1])];
      if (arg === undefined) {
        arg = keepPlaceholder ? match[0] : '';
        lastIndex = keepPlaceholder ? regex.lastIndex : lastIndex;
      }
      // tslint:disable-next-line: no-parameter-reassignment
      t = t.replace(match[0], arg);
      // tslint:disable-next-line: max-line-length
      regex.lastIndex = lastIndex; // Bug #1 - Need to reset the position in case the placeholder is longer than the value
      match = regex.exec(t);
    }

    return t;
  }
}
